import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
//to do exportColumns excel
export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'code', fieldTitle: t('Κωδικός Εντύπου'), fieldType: 'TEXT' },
    { fieldName: 'orderedDate', fieldTitle: t('Ημερομηνία Αίτησης'), fieldType: 'DATE' },
    { fieldName: 'dateCollected', fieldTitle: t('Ημερομηνία Συλλογής'), fieldType: 'DATE' },
    { fieldName: 'collectionDetails', fieldTitle: t('Σημείο Συλλογής'), fieldType: 'TEXT' },
    { fieldName: 'collector.name', fieldTitle: t('Συλλέκτης'), fieldType: 'TEXT' },
    { fieldName: 'wastereceptionpoint.name', fieldTitle: t('Προορισμός'), fieldType: 'TEXT' },
    // Να ρωτήσω τον Φιλίππο για το collectionLinesDetails fieldTitle
    { fieldName: 'collectionLinesDetails', fieldTitle: t('Στοιχέια Συλλογής'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);

    function transformData(data) {
      console.log('data', data.getCollections.data);
      const recs = data.getCollections.data.map((values) => {
        return {
          ...values,
          collectionDetails: values.collectionpoint
            ? `${values.collectionpoint.name ?? ''} - ${values.collectionpoint.address ?? ''}`
            : '',
          collectionLinesDetails: values.collectionLines
            ? values.collectionLines
                .map(
                  (collection) =>
                    `${collection.material.name} - ${collection.qty}τμχ -${collection.netWeight}kg`,
                )
                .join(', ')
            : '',
        };
      });
      const trsData = {
        getCollections: { data: recs, recordCount: data?.getCollections?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
    //return [null, { loading: null, data: null }];
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'Collections',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}

